import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import {FilteredSearchInput, ConfirmationDialog, FormContext, IndexContext, LinkButton} from '..'
import { debounce } from '../../utils'
import StyleSheet from '../../styles'
import {deepMerge} from '../../utils/CollectionUtils'
import {darkThemeDefinition} from '../../styles/AppStyles'
import {createMuiTheme} from '@material-ui/core/styles/index'
import {MuiThemeProvider} from '@material-ui/core/styles'
import {styles as dtpStyles} from '../DateTimePicker'

export class SearchComboInput extends Component{
  static propTypes = {
    className: PropTypes.string,
    onFilterChange: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string,
    searchTextMember: PropTypes.string
  }

  static defaultProps = {
    className: '',
    hasFiltersApplied: false,
    dialogTitle: 'Filters',
    searchTextMember: 'freeText'
  }

  constructor(props) {
    super(props)

    this.state = {
      filtersOpen: false,
      filter: props.filter
    }
  }

  get hasFiltersApplied(){
    return Object.values(this.props.filter).some(x => x)
  }

  handleChange = debounce(() => {
    this.props.onFilterChange(this.state.filter)
  })

  handleOpenFilters = () => {
    this.setState({
      filtersOpen: true,
      filter: this.props.filter
    })
  }

  handleCloseFilters = () => {
    this.setState({filtersOpen: false})
  }

  handleFilterConfirm = () => {
    this.handleChange()
    this.handleCloseFilters()
  }

  handleFilterCancel = () => {
    this.setState({filter: this.props.filter})
    this.handleCloseFilters()
  }

  handleTextChange = ({target: { value: filterText }}) => {
    this.setState({
      filter: {...this.state.filter, [this.props.searchTextMember]: filterText }
    }, this.handleChange)
  }

  handleFilterChanged = (filter) => {
    this.setState({filter})
  }

  handleResetFilter = () => {
    this.setState({filter: {}})
  }

  render = () => {
    const { dialogTitle, children, searchTextMember, onFilterChange, ...textFieldProps } = this.props
    const { filter, filtersOpen } = this.state
    return (
      <Fragment>
        <FilteredSearchInput
          {...textFieldProps}
          onOpenFilters={this.handleOpenFilters}
          onChange={this.handleTextChange}
          hasFiltersApplied={this.hasFiltersApplied}
          value={filter[searchTextMember] || ''}
        />
        <ConfirmationDialog
          title={dialogTitle}
          open={filtersOpen}
          onConfirm={this.handleFilterConfirm}
          onCancel={this.handleFilterCancel}
          confirmLabel={'Filter'}
          cancelLabel={'Cancel'}
        >
          <MuiThemeProvider theme={formTheme}>
            <div className={styles.form}>
              <FormContext onChange={this.handleFilterChanged} context={filter}>
                {children}
                <LinkButton className={styles.reset} onClick={this.handleResetFilter}>Reset Filters</LinkButton>
              </FormContext>
            </div>
          </MuiThemeProvider>
        </ConfirmationDialog>

      </Fragment>
    )
  }
}

const formTheme =
  createMuiTheme(deepMerge(darkThemeDefinition, {
    typography: {
      h5: {
        padding: [20, 0, 10, 0],
        margin: [0, 10, 30, 0],
      },
      h6: {
        padding: [5, 0]
      },
      subtitle1: {
        paddingTop: 25
      }
    },
    overrides: {
      MuiFormControl: {
        root: {
          width: '50%',
          paddingRight: 10,
          paddingBottom: 10,
          boxSizing: 'border-box'
        }
      },
      MuiFormControlLabel: {
        root: {
          marginRight: 32,
        }
      },
      MuiFormGroup: {
        root: {
          flexDirection: 'row',
        }
      },
      MuiButton: {
        root: {
          width: 266,
          marginRight: 20,
          marginBottom: 20,
        }
      },
      MuiInputLabel: {
        animated: {
          whiteSpace: 'nowrap'
        }
      },
    }
  }))

const styles = StyleSheet({
  reset: {
    'button&': {
      color: '#6AAEAA',
      fontWeight: 'bold',
      fontSize: '14px',
      fontFamily: 'Montserrat,sans-serif',
      marginTop: 20,
      display: 'inline-block'
    }
  },
  form: {
    opacity: 1,
    transition: 'opacity 500ms',
    maxWidth: 556,
    width: '100%',
    marginBottom: 15,
    [`& .${dtpStyles.dateWrapper}`]: {
      width: '50%',
      boxSizing: 'border-box',
      display: 'inline-flex'
    },
  },
})

export default class SearchComboInputWrapper extends Component {
  render = () =>
    <IndexContext.Consumer>{value => <SearchComboInput {...value} {...this.props} />}</IndexContext.Consumer>
}